/* unplugin-vue-components disabled */import { render } from "./richText.vue?vue&type=template&id=1f1f185b&scoped=true"
import script from "./richText.vue?vue&type=script&lang=js"
export * from "./richText.vue?vue&type=script&lang=js"

import "./richText.vue?vue&type=style&index=0&id=1f1f185b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1f185b"]])

export default __exports__